// removed by extract-text-webpack-plugin
module.exports = {"notification":"Notification-hashed__notification__3Z1yy","notification_open":"Notification-hashed__notification_open__15Tfo","notification__displacededstuff":"Notification-hashed__notification__displacededstuff__3UkJt"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/MobileNotification/Notification-hashed.scss
// module id = 1233
// module chunks = 0